// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editor {\n  width: 100%;\n  margin: 0 auto;\n}\n.toolbar {\n  border: 1px solid #ccc;\n}\n.wtext {\n  border: 1px solid #ccc;\n  height: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
